export enum RiskCreatedByFields {
  USER = 'user',
  AUTOMATION = 'automation',
}
